

















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class RadioCheckbox extends Vue {
    @Prop() value!: boolean;
    @Prop() trueString!: string;
    @Prop() falseString!: string;
    @Prop() disabled!: string;

    setTrue()
    {
        if (this.currentValue == true)
            this.$emit('input', null);
        else
            this.$emit('input', true);
    }

    setFalse() {
        if (this.currentValue == false)
            this.$emit('input', null);
        else
            this.$emit('input', false);
    }

    get currentValue(): boolean{
        return this.value;
    }
}
